import * as React from 'react';
import Sheet from '@mui/joy/Sheet';

import MessagesPane from '../../redux/containers/chat/MessagesPane';
import ChatsPane from './ChatsPane';

export default function Chat(props) {
  const [selectedChat, setSelectedChat] = React.useState();
  const [selectedChatId, setSelectedChatId] = React.useState();
  const [users, setUsers] = React.useState([]);
  const [chatMessages, setChatMessages] = React.useState([]);
  const { getUsers, selectedUsersId, profile, sucursal_id, sendCustomMessage } =
    props;

  React.useEffect(() => {
    setChatMessages([]);
    getUsers(profile.tenant_id, sucursal_id, props.conversation_id);
  }, [sucursal_id]);

  const handleRefresh = () => {
    setChatMessages([]);
    getUsers(profile.tenant_id, sucursal_id, props.conversation_id);
  };

  React.useEffect(() => {
    if (props.users) {
      if (selectedUsersId) {
        const filteredUsers = props.users.filter(user =>
          selectedUsersId.includes(parseInt(user.user_id)),
        );
        setUsers(filteredUsers);
        setSelectedChat({
          user_id: filteredUsers[0]?.user_id,
          user_profile: filteredUsers[0]?.user_profile,
        });
        setSelectedChatId(filteredUsers[0]?.user_id);
      } else {
        setUsers(props.users);
        setSelectedChat({
          user_id: props.users[0]?.user_id,
          user_profile: props.users[0]?.user_profile,
        });
        setSelectedChatId(props.users[0]?.user_id);
      }
    }
  }, [props.users, selectedUsersId]);

  return (
    <Sheet
      sx={{
        flex: 1,
        width: '100%',
        mx: 'auto',
        pt: { xs: 'var(--Header-height)', md: 0 },
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(min-content, min(30%, 400px)) 1fr',
        },
      }}>
      <Sheet
        sx={{
          position: { xs: 'fixed', sm: 'sticky' },
          transform: {
            xs: 'translateX(calc(100% * (var(--MessagesPane-slideIn, 0) - 1)))',
            sm: 'none',
          },
          transition: 'transform 0.4s, width 0.4s',
          zIndex: 100,
          width: '100%',
          top: 52,
        }}>
        <ChatsPane
          chats={users}
          number_of_unread_messages={props.number_of_unread_messages}
          selectedChatId={selectedChatId}
          setSelectedChatId={setSelectedChatId}
          setSelectedChat={setSelectedChat}
          handleRefresh={handleRefresh}
        />
      </Sheet>
      <MessagesPane
        selectedChatId={selectedChatId}
        getUserMessages={props.getUserMessages}
        selectedChat={selectedChat}
        userMessages={props.userMessages}
        tenant_id={profile.tenant_id}
        sucursal_id={sucursal_id}
        sendCustomMessage={sendCustomMessage}
        agent_name={profile.username}
        chatMessages={chatMessages}
        setChatMessages={setChatMessages}
        conversation_id={props.conversation_id}
      />
    </Sheet>
  );
}
